import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { AssigneeSelect } from 'components/common/AssigneeSelect/AssigneeSelect';

import { CustomizedFormErrorMessage } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';

export const AssigneeInput = () => {
    const form = useFormContext<FormProps>();
    return (
        <div className={classes.row}>
            <Controller
                render={({ field }) => (
                    <AssigneeSelect
                        {...field}
                        id={'bulk-assignee'}
                        isClearable={true}
                        placeholder={'Assign all risks...(optional)'}
                    />
                )}
                name={'assignee'}
                control={form.control}
            />
            {form.formState.errors.assignee && (
                <CustomizedFormErrorMessage text={form.formState.errors.assignee.message} />
            )}
        </div>
    );
};
